import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, BackButton, ColorBatch, SignDocument } from 'components';
import { showApiError } from 'utils';
import { getCredit } from 'services';
import { creditsStatusName, creditStatusColorMap, CREDIT_STATUS } from 'enums';
import { headerLeftTitle, headerLeftSubTitle, headerLeftId } from 'styles';
import { infoBox } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var awaiting_approval = CREDIT_STATUS.awaiting_approval;

var SignCredit = function SignCredit(_ref) {
  var _location$state, _match$params, _creditData$borrower, _creditData$borrower2, _creditData$borrower3;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      credit = _ref2.credit;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      creditId = _ref3.creditId;

  var _useState = useState(credit),
      _useState2 = _slicedToArray(_useState, 2),
      creditData = _useState2[0],
      setCreditData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      noDocuments = _useState4[0],
      setNoDocuments = _useState4[1];

  useEffect(function () {
    fetchCreditData();
  }, []);

  var fetchCreditData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(redirect) {
      var _yield$getCredit, _yield$getCredit2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCredit(creditId);

            case 2:
              _yield$getCredit = _context.sent;
              _yield$getCredit2 = _slicedToArray(_yield$getCredit, 2);
              res = _yield$getCredit2[0];
              err = _yield$getCredit2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setCreditData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), res);
              });
              redirect && history.push({
                pathname: (res === null || res === void 0 ? void 0 : res.status) === awaiting_approval ? "/credits/details/".concat(creditId) : "/credits/pay/".concat(creditId),
                state: {
                  credit: res
                }
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCreditData(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em 2em 0 2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/credits');
    }
  }), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "\u041D\u043E\u043C\u0435\u0440: ", creditData === null || creditData === void 0 ? void 0 : creditData.number), ___EmotionJSX("h6", {
    css: headerLeftSubTitle
  }, "\u0421\u0443\u043C\u0430: ", creditData === null || creditData === void 0 ? void 0 : creditData.amount, " ", creditData === null || creditData === void 0 ? void 0 : creditData.currency), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower = creditData.borrower) === null || _creditData$borrower === void 0 ? void 0 : _creditData$borrower.first_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower2 = creditData.borrower) === null || _creditData$borrower2 === void 0 ? void 0 : _creditData$borrower2.middle_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower3 = creditData.borrower) === null || _creditData$borrower3 === void 0 ? void 0 : _creditData$borrower3.last_name), ___EmotionJSX(ColorBatch, {
    type: creditStatusColorMap[creditData === null || creditData === void 0 ? void 0 : creditData.status],
    fontSize: "1rem",
    margin: "0 0 0 6px"
  }, creditsStatusName[creditData === null || creditData === void 0 ? void 0 : creditData.status])))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "0 2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, !noDocuments ? ___EmotionJSX(SignDocument, {
    creditId: Number(creditId),
    credit: creditData,
    onNext: function onNext() {
      return fetchCreditData(true);
    },
    onNoDocuments: function onNoDocuments() {
      return setNoDocuments(true);
    }
  }) : ___EmotionJSX("div", {
    css: infoBox
  }, ___EmotionJSX("p", null, "\u041D\u044F\u043C\u0430\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0437\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0432\u0430\u043D\u0435!")))));
};

SignCredit.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default SignCredit;